function initPrimaryNav (hamburger) {
  const IS_ACTIVE_CLASS = 'is-active';
  const HEADER_NAVIGATION = '.header__navigation';
  const bodyElement = document.querySelector('body');

  hamburger.addEventListener('click', () => {
    if (hamburger.classList.contains(IS_ACTIVE_CLASS)) {
      hamburger.classList.remove(IS_ACTIVE_CLASS);
      document.querySelector(HEADER_NAVIGATION).classList.remove(IS_ACTIVE_CLASS);
      bodyElement.classList.remove(IS_ACTIVE_CLASS);
    } else {
      hamburger.classList.add(IS_ACTIVE_CLASS);
      document.querySelector(HEADER_NAVIGATION).classList.add(IS_ACTIVE_CLASS);
      bodyElement.classList.add(IS_ACTIVE_CLASS);
    }
  });

  // document.querySelectorAll('.navigation__anchor')
}

function initScrollHeader (body) {
  let scrollPosition = window.scrollY;

  function updateState (event) {
    const position = window.scrollY;
    if (scrollPosition < position && scrollPosition > 205) {
      body.classList.add('scrolled');
    } else if (scrollPosition > position) {
      body.classList.remove('scrolled');
    }
    scrollPosition = position;
  }

  updateState();
  window.addEventListener('scroll', updateState);
}

export default function () {
  document.querySelectorAll('.hamburger').forEach(initPrimaryNav);
  initScrollHeader(document.querySelector('body'));
}
